module.exports = __webpack_public_path__ + "assets/img/maximize.e421b823.svg";